import { ToastrManager } from 'ng6-toastr-notifications';
import { Partner } from './../partner.model';
import { PartnersService } from './../partiners.service';
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-partiners-detail',
  templateUrl: './partiners-detail.component.html',
  styleUrls: ['./partiners-detail.component.css']
})
export class PartinersDetailComponent implements OnInit,OnDestroy {

  public partner:Partner;

  private detailSubscription:Subscription;

  constructor(public partnerServ: PartnersService,public navigator:Router,public toastr:ToastrManager) {
    this.detailSubscription=new Subscription();
   }

  ngOnDestroy(): void {
    if(this.detailSubscription) return

    this.detailSubscription.unsubscribe();
  }

  ngOnInit() {
    this.detailSubscription.add(this.partnerServ.getObject('partner').subscribe(partner=>this.partner=partner));
  }

  editPartner(partner:Partner){
    this.navigator.navigate(['/admin/partners/edit']).then(()=>{
      this.partnerServ.setObject(partner,'partner');
    })
  }

  updateImageProfile(event:any,partner:any){
    if(confirm('Deseja realmente actualizar o Logotipo?')){

            // criando um formData
            let formData = new FormData();


            // convertendo o formpartner para formData
            formData.append('id', partner['id'])
      
            console.log(event.target.files[0])
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('picture', event.target.files[0], event.target.files[0].name)

      // save image
      this.partnerServ.updateImageWithNoData(formData,'patner')
      .subscribe(message=>{
        this.toastr.successToastr(message)
      })

    }
  }

}
